import {
  faRotateLeft,
  faRotateRight,
} from '@fortawesome/pro-regular-svg-icons';
import { useMediaRemote, useMediaState } from '@vidstack/react';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { PlayerControlButton } from './base-button';
import { useVideoPlayerContext } from '../../player-context';

export const QuickSeek = () => {
  const { playerRef } = useVideoPlayerContext();
  const currentTime = useMediaState('currentTime', playerRef!);
  const remote = useMediaRemote(playerRef);
  const handleRotateLeft = useCallback(() => {
    remote.seek(currentTime - 10);
  }, [currentTime, remote]);
  const handleRotateRight = useCallback(() => {
    remote.seek(currentTime + 10);
  }, [currentTime, remote]);

  return (
    <div className="flex">
      <PlayerControlButton
        icon={faRotateLeft}
        onClick={handleRotateLeft}
        tooltipContent={
          <FormattedMessage id="account.meeting_transcript.player.controls.quick_seek.left" />
        }
      />
      <PlayerControlButton
        icon={faRotateRight}
        onClick={handleRotateRight}
        tooltipContent={
          <FormattedMessage id="account.meeting_transcript.player.controls.quick_seek.right" />
        }
      />
    </div>
  );
};
